import imgUrlLiving from '../assets/images/home/girl-playing-the-piano.jpg'
import imgUrlNurse from '../assets/images/home/doctor with men.jpg'
import imgUrlParticipation from '../assets/images/home/women-sitting-in-a-cafe.jpg'
import imgUrlOptions from '../assets/images/home/Entering-the-New-House.jpg'
import imgUrlAccommodation from '../assets/images/home/room with table and chair.jpg'
import imgUrlTransport from '../assets/images/home/the man helps old man.jpg'
import imgUrlCoordination from '../assets/images/home/flower boy.jpg'
import imgUrlManagment from '../assets/images/home/iStock-1336665139.jpg'

export const phoneNumber = '1800 462 070'
export const email = 'info@blossomcds.com.au'

export const services = [
	{
		img: imgUrlLiving,
		header: 'Supported Independent Living',
		link: '/services/independent-living',
		alt: '',
	},
	{
		img: imgUrlNurse,
		header: 'Registered Nurse Services',
		link: '/services/community-nursing-care',
		alt: '',
	},
	{
		img: imgUrlParticipation,
		header: 'Community Participation',
		link: '/services/community-participation',
		alt: '',
	},
	{
		img: imgUrlOptions,
		header: 'Individualised Living Options',
		link: '/services/independent-living',
		alt: '',
	},
	{
		img: imgUrlAccommodation,
		header: 'Specialist Disability Accommodation',
		link: '/services/dissability-accommodation',
		alt: '',
	},
	{
		img: imgUrlTransport,
		header: 'Transport',
		link: '/services/plan-management',
		alt: '',
	},
	{
		img: imgUrlCoordination,
		header: 'Support Coordination',
		link: '/services/support-coordination',
		alt: '',
	},
]

/*{ img: imgUrlManagment, header: 'Plan Management', link: '/services/transport', alt: '' }*/

export const fontSize = {
	topper: {
		first: 0.8125,
		second: 1,
		middle: 1.6,
		onePix: 0.0625,
	},

	header: {
		first: 1.9375,
		second: 3.0625,
		middle: 3.9,
		onePix: 0.0625,
	},

	body: {
		first: 1,
		onePix: 0.0625,
	},

	p: {
		first: 1,
		second: 1.25,
		middle: 2.3,
		onePix: 0.0625,
	},

	button: {
		first: 1,
		onePix: 0.0625,
	},

	topperTextSize: {
		first: 0.8125,
		second: 1,
		middle: 1.6,
		onePix: 0.0625,
	},

	hText: {
		first: 2.4375,
		second: 3.8125,
		middle: 6.4,
		onePix: 0.0625,
	},

	ctaText: {
		first: 0.875,
		second: 1.25,
		middle: 1.5,
		onePix: 0.0625,
	},

	ctaHeader: {
		first: 1.25,
		second: 1.5625,
		middle: 2.4,
		onePix: 0.0625,
	},

	input: {
		first: 0.875,
		second: 1,
		middle: 1.5,
		onePix: 0.0625,
	},

	contact: {
		first: 1.25,
		onePix: 0.0625,
	},
}

export const colors = {
	primary: { color: '#00CA89' },
	secondary: { color: '#F11D7C' },
	secondaryLight: { color: '#F791B2' },
	backgroundColor: { color: '#FFF8F5' },
}
